import React from 'react';
import { observer } from 'mobx-react-lite';
import { InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { LanguageSelectType } from 'src/AppState/LanguageState/LanguageState';
import { useAppStateContext } from 'src/AppState/AppState';
import { SelectNative } from 'src/domains/layouts/shared/formComponents/Select/SelectNative';
import { OptionElement } from 'src/domains/layouts/shared/formComponents/Select/SelectNative.style';

interface LanguageSelectionType {
    className?: string;
    selectOptions: Array<LanguageSelectType>;
    setAction: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    value: string;
}

/**
 * @deprecated - Please use Select.tsx or OldSelect.tsx from layouts/shared instead
 */

export const LanguagesSelect = observer(({className, selectOptions, setAction, value }: LanguageSelectionType) => {
    const { languageState } = useAppStateContext();

    return (
        <>
            <InputLabel>Pick a language version</InputLabel>

            <SelectNative
                className={className}
                dataTest='pages-pick-lang-version'
                onChange={setAction}
                value={value}
            >
                {languageState.languages.length > 0 ?
                    selectOptions.map((option: LanguageSelectType) => {
                        return (
                            <OptionElement key={option.key} value={option.key}>
                                {option.value}
                            </OptionElement>
                        );
                    }) : null}
            </SelectNative>
        </>
    );
});
